import * as React from "react";
import { forwardRef, memo } from "react";
const SvgFilledPendingIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 40, cy: 40, r: 30, fill: "#F3BA58", stroke: "#F3BA58", strokeWidth: 7.5 }), /* @__PURE__ */ React.createElement("ellipse", { cx: 40, cy: 57, rx: 4, ry: 4, fill: "white" }), /* @__PURE__ */ React.createElement("rect", { x: 36, y: 19, width: 8, height: 29, rx: 4, fill: "white" }));
const ForwardRef = forwardRef(SvgFilledPendingIcon);
const Memo = memo(ForwardRef);
export default Memo;
